export default __webpack_public_path__ + "static/media/CompanyLogo.69e80c6c.svg";